// Class: motion.easing._Sine.SineEaseOut

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../../hxClasses_stub").default;
var $import = require("./../../../import_stub").default;
function motion_easing_IEasing() {return require("./../../../motion/easing/IEasing");}

// Constructor

var SineEaseOut = function() {
}

// Meta

SineEaseOut.__name__ = ["motion","easing","_Sine","SineEaseOut"];
SineEaseOut.__isInterface__ = false;
SineEaseOut.__interfaces__ = [(motion_easing_IEasing().default)];
SineEaseOut.prototype = {
	calculate: function(k) {
		return Math.sin(k * (Math.PI / 2));
	},
	ease: function(t,b,c,d) {
		return c * Math.sin(t / d * (Math.PI / 2)) + b;
	}
};
SineEaseOut.prototype.__class__ = SineEaseOut.prototype.constructor = $hxClasses["motion.easing._Sine.SineEaseOut"] = SineEaseOut;

// Init



// Statics




// Export

exports.default = SineEaseOut;